// src/components/Work.jsx
import React from 'react';
import './Work.css';

const Work = () => (
  <div>
    <section id="work" className="relative text-white" style={{ height: '446px', width: '100%' }}>
      <div className="absolute inset-0 flex items-center justify-center" style={{ zIndex: 1, maxWidth: '980px', margin: '0 auto' }}>
        <div className=" px-20 text-left  pt-20 pb- mt-80 mb-20 bg-white rounded-lg" style={{ maxWidth: '970px', fontFamily: 'Montserrat, sans-serif', fontWeight: 'lighter', color: '#000' }}>
          <h2 className="font-bold mb-4" style={{ fontSize: '47px', marginBottom: '70px' }}>
            Structural designs that are simple, efficient, and easily constructible.
          </h2>
          <p className="mb-4" style={{ fontSize: '15.1px', maxWidth: '658' }}>
            From prototype rollouts for the largest corporations, to mid-size shell buildings for small developers, Rubix specializes in the design of structural systems in wood, concrete, and steel.
          </p>
          <p style={{ fontSize: '16px' }}>
            Here are a few examples of our work.
          </p>
        </div>
      </div>
      <img src="/assets/work/workmain.png" alt="Background" className="absolute inset-0 w-full h-full object-cover object-center" style={{ objectFit: 'cover', objectPosition: '50% 50%', zIndex: 0 }} />
    </section>

    

    </div>
);

export default Work;
